import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductSwitchOfferQuery } from "src/api/productSwitchOffers";
import { BillingCyclePreviewProto } from "@noom/noom-contracts/noom_contracts/billing/bms/subscriptions/billing_cycle_preview";
import type { InvoiceProto } from "@noom/noom-contracts/noom_contracts/billing/bms/invoices/invoice";
import { MoneyProto } from "@noom/noom-contracts/noom_contracts/lib/money";

export type ProductSwitchPreviewOrder = {
  loading?: boolean;
  error?: boolean;
  initialBillingCycle?: BillingCyclePreviewProto;
  recurringBillingCycle?: BillingCyclePreviewProto;
  refundAmount?: MoneyProto;
};

export type CurrentSubscriptionInfo = {
  subscriptionId: string;
  productName?: string;
  trialInvoice?: InvoiceProto;
  recurringBillingCycle?: BillingCyclePreviewProto;
};

export type ProductSwitchState = {
  loaded: boolean;
  currentSubscription?: CurrentSubscriptionInfo;
  offers: ProductSwitchOfferQuery[];
  selectedOffer: ProductSwitchOfferQuery | null;
  isDeferredSwitch: boolean;
  switchStartDate: string | null;
  previewOrders: Record<string, ProductSwitchPreviewOrder>;
};

const initialState: ProductSwitchState = {
  loaded: false,
  offers: [],
  selectedOffer: null,
  isDeferredSwitch: false,
  switchStartDate: null,
  previewOrders: {},
};

const productSwitchSlice = createSlice({
  name: "productSwitch",
  initialState,
  reducers: {
    setProductSwitchData(
      state,
      action: PayloadAction<Partial<ProductSwitchState>>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setPreviewOrder(
      state,
      action: PayloadAction<{
        productName: string;
        previewOrder: ProductSwitchPreviewOrder;
      }>
    ) {
      return {
        ...state,
        previewOrders: {
          ...state.previewOrders,
          [action.payload.productName]: action.payload.previewOrder,
        },
      };
    },
    clearProductSwitchData() {
      return initialState;
    },
  },
});

export const { setProductSwitchData, setPreviewOrder, clearProductSwitchData } =
  productSwitchSlice.actions;

export default productSwitchSlice;
